module.exports = __webpack_public_path__ + "img/public/SiteIcons/securityIcon1.svg?c4639ff8";